import { useEffect, useRef, useState } from "react";

/** TODO: The interactions have to save event. */
function ReadAndAnswerCode({ activityid, questiondata, onLoadExisting }) {
  const linesOfCode = questiondata.linesOfCode || [];
  const [highlighted, setHighlighted] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    onLoadExisting(activityid);
  }, [activityid, onLoadExisting]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setHighlighted(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLineClicked = (index) => {
    setHighlighted(index === highlighted ? null : index);
  };

  const codeLines = linesOfCode.map((line, index) => {
    const isSelected = highlighted === index;
    return (
      <div key={index} className="relative flex min-w-full">
        <div
          className={`pl-1 pr-4 text-right text-gray-500 ${isSelected ? "font-bold" : ""}`}
          style={{
            width: "2.5rem",
            flexShrink: 0,
          }}
        >
          {index + 1}
        </div>
        <div
          className={`flex-grow min-h-[1.5rem] px-2 transition-colors duration-150 ${
            isSelected ? "bg-yellow-300" : index % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
          }`}
          style={{
            cursor: line.explanation ? "help" : "default",
          }}
          onClick={() => handleLineClicked(index)}
        >
          <div className="text-left font-mono" style={{ whiteSpace: "pre-wrap" }}>
            {line.code}
          </div>

          {/* Popup with explanation */}
          {isSelected && line.explanation && (
            <div className="absolute left-12 top-full mt-1 w-64 p-2 bg-white border border-gray-300 rounded-md shadow-lg text-sm text-gray-700 z-20">
              {line.explanation}
            </div>
          )}
        </div>
      </div>
    );
  });

  return (
    <div ref={containerRef} className="flex items-start flex-col">
      {codeLines}
    </div>
  );
}

export default ReadAndAnswerCode;
